import { Injectable } from '@angular/core';
import { CTVModel } from 'src/app/Models/ctv-model';
import { NotifyService } from 'src/app/Services/notify.service';
enum ERROR_CODES {
  ALLOWED_ONLY_VARIABLE = "The given value should only be a variable starting with '##' and followed by letters.",
  ALLOWED_ONLY_NUMBERS = "The given value should only consist of numbers.",
  ALLOWED_ONLY_PARAMETER = "The given value should only be a parameter starting with @@.",
  ALLOWED_ONLY_NUMBERSEPRATEDBYCOMMA = "The given value should consist only of numbers separated by commas.",
  EMPTY_OBJECT = "The object should not be left empty.",
  EMPTY_VALUE = "The value should not be left empty.",
}
@Injectable({
  providedIn: 'root'
})
export class ValidationService {
  errorCounter = 0;
  constructor(
    private notifys: NotifyService,
  ) { }
  containsOnlyNumbers(str) {
    return /^-?\d+(\.\d+)?$/.test(str);
  }
  containsOnlyVariable(str) {
    return /^##[a-zA-Z]+\d{0,}$/.test(str);
  }
  containsOnlyParameters(str) {
    return /^@@[a-zA-Z]+\d{0,}$/.test(str);
  }
  dragdropOffsetValidation(str) {
    return /^\d+,\d+$/.test(str);
  }
  warningCounter = 0;
  validationIcon = false;


  validateCTV(ctvList: CTVModel[], showErrorMessage:Boolean) {
    this.errorCounter = 0;
    this.warningCounter = 0;
    ctvList.forEach(element => {
      element.errors = {};
      element.warnings = {};
      if(element.active !== false || !element["deleted"] || element["deleted"] != 1) {
        switch (element.command.name.toLowerCase()) {

          // value can contain only variable
          // case 'get current url':
          case 'else if equals to':
          case 'else if equals ignore case':
          case 'if equals to':

          case 'if not equals ignore case':
            
          case 'else if not equals to':

          case 'else if not equals ignore case':
            // break;
          case 'if equals ignore case':
            if ((!element.value2)) {
              element.errors['value2'] = ERROR_CODES.EMPTY_VALUE;
              this.errorCounter += 1;
            }
            if ((!element.value)) {
              element.errors['value1'] = ERROR_CODES.EMPTY_VALUE;
              this.errorCounter += 1;
            }
            break;
          case 'set value':
            if (!this.containsOnlyVariable(element.value)) {
              element.errors['value1'] = ERROR_CODES.ALLOWED_ONLY_VARIABLE
              this.errorCounter += 1;
            }
            break;
  
          // value can contain only numbers and @@
          case 'close window':
          case 'pause':
          case 'switch tab using index':
          case 'switch To iFrame By Index':
            if (!this.containsOnlyParameters(element.value) && (!this.containsOnlyNumbers(element.value))) {
              element.errors['value1'] = ERROR_CODES.ALLOWED_ONLY_NUMBERS + ' or ' + ERROR_CODES.ALLOWED_ONLY_PARAMETER;
              this.errorCounter += 1;
            }
            break;
  
          // value can contain variable and value2 contain only numbers and @@
          case 'if greater than':
            // break;
          case 'if less than':

          case 'else if greater than':

          case 'else if less than':

          case 'if greater than or equals to':

          case 'if less than or equals to':

          case 'else if greater than or equals to':

          case 'else if less than or equals to':

          // break;
          case 'loop equals':
            // break;
          case 'loop less than':
            if (!this.containsOnlyVariable(element.value) && !this.containsOnlyParameters(element.value) && !this.containsOnlyNumbers(element.value)) {
              element.errors['value1'] = ERROR_CODES.ALLOWED_ONLY_VARIABLE + ' or ' + ERROR_CODES.ALLOWED_ONLY_NUMBERS + ' or ' + ERROR_CODES.ALLOWED_ONLY_PARAMETER;
              this.errorCounter += 1;
            }
            if (!this.containsOnlyVariable(element.value2) && !this.containsOnlyParameters(element.value2) && (!this.containsOnlyNumbers(element.value2))) {
              element.errors['value2'] = ERROR_CODES.ALLOWED_ONLY_NUMBERS + ' or ' + ERROR_CODES.ALLOWED_ONLY_PARAMETER;
              this.errorCounter += 1;
            }
            break;
            
          case 'get current url':
            if (!this.containsOnlyVariable(element.value) ) {
              element.errors['value1'] = ERROR_CODES.ALLOWED_ONLY_VARIABLE ;
              this.errorCounter += 1;
            }
            break;
  
          case 'add':
          case 'division':
          case 'multiplication':
          case 'subtract':
            if (!this.containsOnlyVariable(element.value)) {
              element.errors['value1'] = ERROR_CODES.ALLOWED_ONLY_VARIABLE
              this.errorCounter += 1;
            }
            if (!(this.containsOnlyVariable(element.value2) || this.containsOnlyNumbers(element.value2))) {
              element.errors['value2'] = ERROR_CODES.ALLOWED_ONLY_NUMBERS + ' or ' + ERROR_CODES.ALLOWED_ONLY_VARIABLE;
              this.errorCounter += 1;
            }
            break;
  
          // case 'drag and drop to offset':
          //   if (!this.dragdropOffsetValidation(element.value)) {
          //     element.errors['value1'] = ERROR_CODES.ALLOWED_ONLY_NUMBERSEPRATEDBYCOMMA
          //     this.errorCounter += 1;
          //   }
          //   break;
          case 'get api':
          case 'post api':
          case 'put api':
          case 'delete api':
          case 'head api':
          case 'options api':
          case 'patch api':
            if (!this.containsOnlyVariable(element.value)) {
              element.errors['value1'] = ERROR_CODES.ALLOWED_ONLY_VARIABLE
              this.errorCounter += 1;
            }
            break;
  
          default:
            if ((element.target == undefined || (element.target['deleted'] == 1)) && (element.command.accepts[0] == ('target'))) {
              element.errors['target'] = ERROR_CODES.EMPTY_OBJECT;
              this.errorCounter += 1;
            }
            if ((element.target2 == undefined || (element.target2['deleted'] == 1)) && (element.command.accepts[1] == ('target'))) {
              element.errors['target2'] = ERROR_CODES.EMPTY_OBJECT;
              this.errorCounter += 1;
            }
            if (this.isDummyTarget(element.target)) {
              if (element.target.warnings == undefined || element.target.warnings == null) {
                element.target['warnings'] = {};
              }
              element.target.warnings['target'] = ERROR_CODES.EMPTY_OBJECT;
              this.warningCounter += 1;
            }
            if (this.isDummyTarget(element.target2)) {
              if (element.target2.warnings == undefined || element.target2.warnings == null) {
                element.target2['warnings'] = {};
              }
              element.target2.warnings['target2'] = ERROR_CODES.EMPTY_OBJECT;
              this.warningCounter += 1;
            }
            if ((!element.value) && (element.command.accepts.toString() == ['value'].toString() ||
              (element.command.accepts.toString() == ['target', 'value'].toString())
            )) {
              element.errors['value1'] = ERROR_CODES.EMPTY_VALUE;
              this.errorCounter += 1;
            }
            if ((element.command.accepts.toString() == ['value', 'value'].toString())) {
              if ((!element.value2)) {
                element.errors['value2'] = ERROR_CODES.EMPTY_VALUE;
                this.errorCounter += 1;
              }
              if ((!element.value)) {
                element.errors['value1'] = ERROR_CODES.EMPTY_VALUE;
                this.errorCounter += 1;
              }
            }
            break;
        }
      }
    });

      const openKeywords = [
        'loop less than', 'loop count', 'loop equal',
        'if greater than', 'if less than', 'if equals to', 'if equals ignore case', 'if element present',
        'else if equals', 'else if equals ignore case', 'else if element present',
        'else', 'else if greater than', 'else if less than', 'if greater than or equals to', 
        'if less than or equals to', 'else if greater than or equals to', 'else if less than or equals to',
        'if not equals ignore case', 'else if not equals to', 'else if not equals ignore case'
      ];
      const closeKeyword = 'close statement';

      const ifKeywords = [
        'if greater than', 'if less than', 'if equals to', 'if equals ignore case', 'if element present', 'if not equals ignore case',
        'if less than or equals to', 'if greater than or equals to'
      ];
      const elseIfKeywords = [
        'else if equals', 'else if equals ignore case', 'else if element present', 'else if not equals ignore case','else if not equals to',
        'else if less than or equals to', 'else if greater than or equals to', 'else if less than', 'else if greater than'
      ];

      const stack: { keyword: string; index: number }[] = [];
      let structureErrors: string[] = [];

      for (let i = 0; i < ctvList.length; i++) {
        const element = ctvList[i];
        const step = element.command.name.trim().toLowerCase();
        if (!step || element["deleted"] == 1 || element.active === false) continue;

        // Check if this is an 'else'
        if (step === 'else') {
          // Find previous non-deleted command
          const prev = [...ctvList]
            .slice(0, i)
            .reverse()
            .find(e => e && e["deleted"] != 1 && e.command.name.trim());

          const prevStep = prev.command.name.trim().toLowerCase();

          // Validate previous must be a 'close statement'
          if (prevStep !== closeKeyword) {
            const msg = `'else' at step ${i + 1} must come immediately after a 'close statement' of an if/else if block.`;
            element.errors['command'] = msg;
            structureErrors.push(msg);
            this.errorCounter++;
          } else {
            const prevCloseIndex = ctvList.indexOf(prev);
            let lastOpenBeforeClose = null;
            for (let j = prevCloseIndex - 1; j >= 0; j--) {
              const s = ctvList[j];
              if (s["deleted"] == 1) continue;
              const cmd = s.command.name.trim().toLowerCase();
              if (openKeywords.includes(cmd)) {
                lastOpenBeforeClose = cmd;
                break;
              }
            }

            if (lastOpenBeforeClose && ![...ifKeywords, ...elseIfKeywords].includes(lastOpenBeforeClose)) {
              const msg = `'else' at step ${i + 1} cannot follow a '${lastOpenBeforeClose}' block (only 'if' or 'else if' allowed).`;
              element.errors['command'] = msg;
              structureErrors.push(msg);
              this.errorCounter++;
            }
          }
        }

        // Opening block
        if (openKeywords.includes(step)) {
          stack.push({ keyword: step, index: i });
        }
        // Close statement
        else if (step === closeKeyword) {
          if (stack.length === 0) {
            const msg = `Unexpected 'close statement' at step ${i + 1}: no opening statement found.`;
            element.errors['command'] = msg;
            structureErrors.push(msg);
            this.errorCounter++;
          } else {
            stack.pop();
          }
        }
      }

      // After traversal, check unclosed blocks
      if (stack.length > 0) {
        stack.forEach(unclosed => {
          const elem = ctvList[unclosed.index];
          const msg = `Missing 'close statement' for '${unclosed.keyword}' at step ${unclosed.index + 1}.`;
          elem.errors['command'] = msg;
          structureErrors.push(msg);
          this.errorCounter++;
        });
      }
      if (structureErrors.length > 0 && showErrorMessage) {
        const combinedMessage = structureErrors.length > 1
          ? structureErrors.map(e => `• ${e}`).join('\n')
          : structureErrors[0];

        this.notifys.notify('error', 'Validation Error', combinedMessage);
        return false;
      }
    this.validationIcon = true;
    console.log("counter for check", this.errorCounter)
    if(showErrorMessage){    
    if (this.errorCounter == 0 && this.warningCounter == 0) {
      return true;
    }
    else if (this.warningCounter != 0) {
      this.notifys.notify('warn', 'Validation Alert: Warnings Detected', 'please fix the warning before executing');
      return true;
    }
    else {
      this.notifys.notify('error', 'Validation Error', 'unable to save');
      return false;
    }
  }
  }

  validateWebObject(targetObject) {
    targetObject.warnings = {};
    if (this.isDummyTarget(targetObject)) {
      targetObject.warnings['target'] = ERROR_CODES.EMPTY_OBJECT;
    }
  }

  isPrimaryLocatorEmpty (targetObject): boolean {
    if (targetObject["primary_locator"] != undefined && targetObject["primary_locator"] != null 
      && ((targetObject["primary_locator"].startsWith("xpath") && targetObject["xpaths"] != undefined 
        && targetObject["xpaths"] != null && targetObject["xpaths"].length > Number(targetObject["primary_locator"].split("_")[1]) 
        && targetObject["xpaths"][Number(targetObject["primary_locator"].split("_")[1])] == "") || (!targetObject["primary_locator"].startsWith("xpath") && ((targetObject[targetObject["primary_locator"]] == undefined) || (targetObject[targetObject["primary_locator"]] != undefined 
          && targetObject[targetObject["primary_locator"]] != null && targetObject[targetObject["primary_locator"]] == ""))))) {
          return true;
    }
    return false;
  }

  isDummyTarget(targetObject) {
    if (targetObject)
      if (
        (targetObject.dom_name == undefined || targetObject.dom_name == "") &&
        // (targetObject.xpath == undefined || targetObject.xpath == "") &&
        (targetObject.xpaths == undefined || !Array.isArray(targetObject.xpaths) || targetObject.xpaths.length === 0 || targetObject.xpaths.every(x => x.trim() === "")) &&
        (targetObject.dom_id == undefined || targetObject.dom_id == "") &&
        (targetObject.class == undefined || targetObject.class == "") &&
        (targetObject.css == undefined || targetObject.css == "") &&
        (targetObject.link == undefined || targetObject.link == "") &&
        (targetObject.horizontal_index == undefined || targetObject.horizontal_index == "") &&       
        (targetObject.partial_link == undefined || targetObject.partial_link == "") &&
        (targetObject.tag == undefined || targetObject.tag == "")
      )
        return true;
      else
        return false;
  }
}